import React, { PureComponent } from "react";

class AutoHeightNotifier extends PureComponent {
	state = {
		styles: {
			height: 0,
			overflow: 'hidden',
			transition: 'all 300ms'
		}
	}

	constructor(props) {
		super(props);
		this.resizeObserver = new ResizeObserver(entries => {
			const currentStyle = { ...this.state.styles };
			entries.forEach(entry => {
				currentStyle.height = entry.contentRect.height;
			});

			this.setState({ styles: currentStyle })
		});
	}

	componentWillUnmount() {
		this.resizeObserver.unobserve(this.ref);
	}

	componentDidMount() {
		this.resizeObserver.observe(this.ref);
	}

	render() {
		return (<div style={ this.state.styles }>
			<div ref={ (ref) => this.ref = ref }>
				{ this.props.children }
			</div>
		</div>);
	}

}

export default AutoHeightNotifier;
